module.exports = __webpack_public_path__ + "img/couple-photo.9108c7ff.jpg";